import React, { useEffect, useState, useCallback } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import Header from "../components/Header";
import Footer from "../components/Footer";

const clearTitle = () => {
  document.getElementById('title').value = "";
}


function AddRating() {
  const [user, loading, error] = useAuthState(auth);
  const [title, setTitle] = useState("");
  const [suggestions, setSuggestions] = useState("");
  const navigate = useNavigate();

  // refactoring: https://typeofnan.dev/fix-function-makes-the-dependencies-of-useEffect-hook-change-on-every-render-warning-in-react/
  const fetchData =  useCallback( async () => {
    if (title.length > 1) {
      try {
        let url =`https://api.themoviedb.org/3/search/movie?api_key=b26b68451b6e675fbb577afdb898aef1&query=${title}`;
        fetch(url)
        .then((response) => response.json())
        .then((data) => {
          //console.log(data.results); 
          setSuggestions(data.results);
          //console.log(url)
        });
        // todo: check if ratingCounter is <= ratingTotalAvailable - if not navigate to account to buy credits
      } catch (err) {
        console.error(err);
        alert("An error occured while fetching user data");
      }
    } else {
      setSuggestions([]);
    }
  }, [title]);






  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchData();
  }, [user, loading, error, navigate, fetchData]);
  //console.log(user);
  return (
    <>
    {loading === false ? (
    <div className="mb-0 px-3 main_screen">

      <Header key="1"  user={user} />

      <h2 className="p-2">Add a rating</h2>

      <div className="p-2 mt-5 align-start">
        <form className="rating_title_form" >
          <label htmlFor="name">Movie title</label>
          <div className="form_box">
            <input
              id="title"
              type="text"
              className="textbox form-control editable"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Title"
              required
            />
            <span className="btn-clear" onClick={(e) => {clearTitle(); setTitle("");}}>Clear</span>
          </div>
          
            <ul className="suggestions">
              {suggestions ? suggestions?.map((el) => ( 
                <li key={el.id}>
                  <a href={"/rate/"+el.id}>
                    <span className="mainTitle">{el.title} <span className="titleYear">{el.release_date?.substring(0,4)}</span></span>
                    <span className="originalTitle">{el.title !== el.original_title ? el.original_title : ""}</span>
                  </a>
                </li>
              )) : ""}
            </ul>    
                  
        </form>
      </div>
      <Footer key="footer" user={user} footertype="back_only"/>
    </div>
    ) : (
    <div className="loadingscreen">
      <div className="loading spinner-border text-warning"></div>
    </div>
    ) }
    </>
  );
}

export default AddRating;
